// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__7s30A","title":"Images90_title__12GxD","images":"Images90_images__33Hvk"};